import { CompanyDto } from '../dto/company.dto'
import { CompanyModel } from '../../models/company.model'

const FALLBACK_MODEL_VALUES = {
  id: -1,
  name: '',
  manager: -1,
  sapCustomerId: -1,
  zeroDeactivated: '',
  locationId: -1,
  shopPermission: false,
  ndaSubmit: '',
  ustId: '',
  partnerNumber: '',
}

const companyDtoToModelTransformer = (values: CompanyDto): CompanyModel => {
  return {
    id: values.ID || FALLBACK_MODEL_VALUES.id,
    name: values.Name || FALLBACK_MODEL_VALUES.name,
    manager: values.Manager || FALLBACK_MODEL_VALUES.manager,
    sapCustomerId: values.sapCustomerID || FALLBACK_MODEL_VALUES.sapCustomerId,
    zeroDeactivated: values.ZERO_deactivated || FALLBACK_MODEL_VALUES.zeroDeactivated,
    locationId: values.Anschrift_ID || FALLBACK_MODEL_VALUES.locationId,
    shopPermission: values.shopPermission || FALLBACK_MODEL_VALUES.shopPermission,
    ndaSubmit: values.NDA_submit || FALLBACK_MODEL_VALUES.ndaSubmit,
    ustId: values.Ust_ID || FALLBACK_MODEL_VALUES.ustId,
    partnerNumber: values.partnerNumber?.toString() || FALLBACK_MODEL_VALUES.partnerNumber,
  }
}

export default companyDtoToModelTransformer
